import { Box } from '@mui/material'

import { BookingAddressType } from 'generated/graphql'

import {
  DeliveryJourneyDetails,
  DeliverySuccess,
  LegalDocuments,
  PackageDetails,
  DeliveryFeedbackActions,
  ProofButton,
} from './ui'

interface DeliveredTrackingSectionProps {
  booking?: any
  bookingCurrentAction?: any
  nextBookingAction?: any
  deliveryTime?: string
  referenceAddressType?: BookingAddressType | null
  collectionAttachmentCount?: number
  deliveryAttachmentCount?: number
  combinedDocAttachmentCount?: number
  onDetailsClick?: () => void
  onProofOfCollectionClick?: () => void
  onProofOfDeliveryClick?: () => void
  onCombinedDocsClick?: () => void
  talkToAnExpertUrl: string
}

const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  px: 2,
  py: 3,
  gap: 2,
  height: '100%',
}

const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
}

const proofButtonRowStyles = {
  display: 'flex',
  gap: 1,
}

export const DeliveredTrackingSection = ({
  booking,
  bookingCurrentAction,
  nextBookingAction,
  deliveryTime,
  referenceAddressType,
  collectionAttachmentCount = 0,
  deliveryAttachmentCount = 0,
  combinedDocAttachmentCount = 0,
  onDetailsClick,
  onProofOfCollectionClick,
  onProofOfDeliveryClick,
  onCombinedDocsClick,
  talkToAnExpertUrl,
}: DeliveredTrackingSectionProps) => {
  const isCollection = referenceAddressType === BookingAddressType.Collection
  const completionType = isCollection ? 'collection' : 'delivery'
  const journeyStatus = isCollection ? 'Collected' : 'Delivered'

  const includesCollection = referenceAddressType == null || isCollection
  const includesDelivery =
    referenceAddressType == null || referenceAddressType === BookingAddressType.Delivery

  const showCollectionProof = includesCollection && collectionAttachmentCount > 0
  const showDeliveryProof = includesDelivery && deliveryAttachmentCount > 0
  const showCombinedDocs = referenceAddressType == null && combinedDocAttachmentCount > 0
  const showProofButtons = showCollectionProof || showDeliveryProof || showCombinedDocs

  return (
    <Box sx={containerStyles}>
      <Box sx={contentWrapperStyles}>
        <LegalDocuments
          ourReference={booking?.ourReference}
          bookingCurrentAction={bookingCurrentAction}
          nextBookingAction={nextBookingAction}
        />

        <DeliverySuccess deliveryTime={deliveryTime} completionType={completionType} />

        {showProofButtons && (
          <>
            <Box sx={proofButtonRowStyles}>
              {showCollectionProof && (
                <ProofButton label='Proof of Collection' onClick={onProofOfCollectionClick} />
              )}
              {showDeliveryProof && (
                <ProofButton label='Proof of Delivery' onClick={onProofOfDeliveryClick} />
              )}
            </Box>
            <Box>
              {showCombinedDocs && (
                <ProofButton
                  label='Combined Proof of Service Documents'
                  onClick={onCombinedDocsClick}
                />
              )}
            </Box>
          </>
        )}

        <DeliveryJourneyDetails status={journeyStatus} />

        <PackageDetails onDetailsClick={onDetailsClick} />
      </Box>

      <DeliveryFeedbackActions talkToAnExpertUrl={talkToAnExpertUrl} />
    </Box>
  )
}
